<template>
  <InfoHeader />
</template>

<script setup lang="ts">
import InfoHeader from '@/vue/InfoHeader.vue';
</script>